import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import GridLayout from '../../../../components/common/GridLayout';
import ColorButton from '../../../../components/common/ColorButton';
import { IS_TAB } from '../../../../utils/common';
import Carousel from '../../../../components/common/Carousel';
import useCarouselItemConfig from '../../../../hooks/useCarouselItemConfig';

const BaseColor = ({
  options,
  updatePartsConfig,
  selectedPart,
  selectedCategory,
  removePartConfig
}) => {
  // const [activeColor, setActiveColor] = useState(
  //   initialSelectedCustomizationIndex
  // );
  // useActiveStateSelector('baseColor', options, partsConfig, setActiveColor);
  // useEffect(() => {
  //   setActiveColor(initialSelectedCustomizationIndex);
  // }, [initialSelectedCustomizationIndex]);
  const [data, setData] = useState(options);

  useEffect(() => {
    setData(options);
  }, [options]);

  const { ref: cardRef, width: itemWidth } = useCarouselItemConfig();

  return (
    <div className="base-color">
      {IS_TAB ? (
        <Carousel
          itemWidth={itemWidth || 70}
          noOfItems={options && options.length}
        >
          {data.map((color, i) => (
            <div className="base-color_item" ref={cardRef}>
              <ColorButton
                color={color.configData.hex}
                text={color.configData.label}
                isSelected={
                  (selectedPart && selectedPart === color.partId) ||
                  (!selectedPart && !color.partId)
                }
                onClick={() => {
                  if (!options[i].partId) {
                    removePartConfig(selectedCategory);
                  } else updatePartsConfig(options[i]);
                }}
              />
            </div>
          ))}
        </Carousel>
      ) : (
        <GridLayout columns={2}>
          {data.map((color, i) => (
            <div className="base-color_item">
              <ColorButton
                color={color.configData.hex}
                text={color.configData.label}
                isSelected={
                  (selectedPart && selectedPart === color.partId) ||
                  (!selectedPart && !color.partId)
                }
                onClick={() => {
                  if (!options[i].partId) {
                    removePartConfig(selectedCategory);
                  } else updatePartsConfig(options[i]);
                }}
              />
            </div>
          ))}
        </GridLayout>
      )}
    </div>
  );
};

BaseColor.propTypes = {
  options: PropTypes.array,
  initialSelectedCustomizationIndex: PropTypes.number,
  updatePartsConfig: PropTypes.func,
  partsConfig: PropTypes.object,
  selectedPart: PropTypes.string
};

export default BaseColor;
